import axios from "axios"
import httpClientErrorHandler from "./httpClientErrorHandler"

export const { CancelToken } = axios

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URI

axios.defaults.headers = {
  Accept: "application/json",
  "Content-Type": "application/json;charset=UTF-8",
  "X-Requested-With": "XMLHttpRequest",
  "Access-Control-Allow-Origin": window.location.origin
}
axios.defaults.withCredentials = true
// 0 == no time out
axios.defaults.timeout = 0

/**
 * Axios middleware as global handler.
 * If you are using redux with HTTP_ACTION, then rejected promise is catch by fetchError midlleware
 * Otherwise, when you're using Axios directly, please ensure that you are catching error.
 */
axios.interceptors.response.use(null, (error) => {
  if (axios.isCancel(error)) {
    return error
  }

  return Promise.reject(httpClientErrorHandler(error))
})
export default axios
